<template>
  <v-container>
    <commentCriteria
      :baseCrudKey="baseCrudKey"
      @loadCRUDList="handleLoadCommentList"
       :commentTypesList="commentTypesList"
    />
    <template>
      <CRUDList
        ref="crudList"
        toolbarTitle="Tax Comments"
        :canAdd="false"
        :canEdit="true"
        :canSave="false"
        :showSelect="true"
        :showDate="true"
        :showTotal="true"
        :enableFixedHeaders="true"
        :displayTopPagination="false"
        :headers="headers"
        :selectedItems="selectedItems"
        :baseCrudKey="baseCrudKey"
        :defaultSortBy="defaultSortBy"
        onlyDialogHeaderName="Comments info"
        dialogDynamicWidth="500"
        tableWrapperDynamicClassname="elevation-3 ma-3 pa-1 taxroll-table-wrapper"
        tableDynamicClassname="taxroll-custom-table"
        tableDynamicHeight="400"
        @upsertItem="upsertTaxComment"
        @emitSelectedItem="emitSelectedItem"
        @loadCRUDList="handleLoadCommentList"
        :loadingData="gridLoading.flag"
        :loadingText="gridLoading.text"
      >
        <template v-slot:[`editedItem`]="{}">
          <commentDialog :baseCrudKey="baseCrudKey"/>
        </template>
      </CRUDList>
    </template>
  </v-container>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import commentCriteria from './CommentCriteria.vue';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import commentDialog from './commentDialog.vue';
import { commentsHeaders } from '../TaxInquiry/TaxInquiryUtils/TableHeaders.utils';
import {
  amountToNumber, defaultGridLoading, extractId, manageGridLoading,
} from '../../../util/shared/vue-global';
import { toIsoDate } from '../../../util/shared/tmc-global';
import { postProcessCommentsTrans, taxReasonListDropDownPostProcessTrans } from '../common-utils/CommonTaxFunctionalities';
import '../../../assets/style.css';

export default {
  name: 'commentSearchTransactionList',
  components: {
    commentCriteria,
    CRUDList,
    commentDialog,
  },
  data() {
    return {
      selectedRows: [],
      headers: commentsHeaders,
      baseCrudKey: 'taxComments',
      selectedRow: null,
      gridLoading: defaultGridLoading(),
      commentTypesList: [],
      isItFirstCallOrNot: false,
    };
  },
  created() {
    this.initCriteria();
  },
  mounted() {
    if (this.defaultTaxYearFromTaxSetting) {
      this.isItFirstCallOrNot = true;
      this.criteriaState.taxYear = this.defaultTaxYearFromTaxSetting;
      this.handleLoadCommentList();
    }
    // if (this.latestTaxYear) {
    //   this.isItFirstCallOrNot = true;
    //   this.criteriaState.taxYear = this.latestTaxYear;
    //   this.handleLoadCommentList();
    // }
  },
  watch: {
    // latestTaxYear(newVal, oldVal) {
    //   if (newVal && !oldVal) this.criteriaState.taxYear = this.latestTaxYear;
    //   if (newVal !== 0) {
    //     this.isItFirstCallOrNot = true;
    //     this.handleLoadCommentList();
    //   }
    // },
    defaultTaxYearFromTaxSetting(newVal, oldVal) {
      if (newVal && !oldVal) this.criteriaState.taxYear = this.defaultTaxYearFromTaxSetting;
      if (newVal !== 0) {
        this.isItFirstCallOrNot = true;
        this.handleLoadCommentList();
      }
    },
  },
  computed: {
    ...mapGetters(['todaysDate']),
    ...mapGetters('base/crud', [
      'criteria',
    ]),
    ...mapGetters('auth/token', ['authUser']),
    ...mapState({
      storeSelectItems: (state) => state.tax.taxComments.selectedItems,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      commentsCategory: (state) => state.base.crud.items.sharedTaxComments,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
    }),
    ...mapGetters('tax/taxComments', ['commentsRows']),
    defaultTaxYearFromTaxSetting() {
      return Number((this.taxSettingItem || {}).taxYear) || 0;
    },
    selectedItems: {
      get() {
        return this.storeSelectItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'createdAt',
          direction: 'desc',
        },
        { column: '_id', direction: 'desc' },
      ];
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('tax/taxComments', ['setSelectedItems']),
    ...mapActions('tax/taxComments', ['loadTaxComments', 'upsertTaxCommentTrans']),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    ...mapActions('shared/taxReasonCode', [
      'loadReasonCode',
    ]),
    emitSelectedItem(value) {
      this.selectedItems = value;
    },
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    initCriteria() {
      this.criteriaState = {};
      this.loadConfig({ requiredScope: 'taxConfig' });
      // this.criteriaState.taxYear = toFiscalYear(new Date(this.todaysDate));
      this.loadReasonCode({
        criteria: { sortBy: [{ column: 'reasonCode', direction: 'asc' }] },
        postProcessTrans: taxReasonListDropDownPostProcessTrans,
        baseCrudKey: 'reasonListDropDown',
      });
    },
    async upsertTaxComment(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      updatedItem.taxId = amountToNumber(updatedItem.taxId);
      updatedItem.userName = this.authUser;
      delete updatedItem.categoryName;
      delete updatedItem.isItCategorySeven;
      if (updatedItem.taxInquiryTransaction) {
        updatedItem.taxInquiryTransaction = extractId(updatedItem.taxInquiryTransaction);
      }
      const response = await this.upsertTaxCommentTrans({
        item: updatedItem,
        baseCrudKey,
        postProcessTrans: this.postProcessTrans,
      });
      this.$nextTick(() => {
        this.selectedItems = [];
      });
      return response;
    },
    async handleLoadCommentList(criteriaArgs = {}) {
      if (this.isItFirstCallOrNot) {
        const { baseCrudKey } = this;
        const criteriaOfComments = this.criteriaState;
        if (criteriaOfComments.sortBy) {
          for (const item of (criteriaOfComments.sortBy || [])) {
            if (item.column === 'categoryName') item.column = 'category';
          }
        }
        const criteria = {
          ...criteriaOfComments,
        };
        criteria.fromDate = criteria.fromDate ? toIsoDate(criteria.fromDate) : null;
        criteria.toDate = criteria.toDate ? toIsoDate(criteria.toDate) : null;
        manageGridLoading(this, true, 'Searching...');
        this.loadTaxComments(
          {
            criteria, baseCrudKey, criteriaArgs, postProcessTrans: this.postProcessTrans,
          },
        ).then((value) => {
          this.buildPostProcess(value);
          this.setDefaultSelectedItems(criteriaArgs);
        }).finally(() => {
          manageGridLoading(this, false);
        });
      }
    },
    postProcessTrans(items) {
      const updatedItems = postProcessCommentsTrans(items, this.commentsCategory);
      return updatedItems;
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },
    buildPostProcess(items) {
      const tempResults = [];
      for (const value of items) {
        value.ownerName = value.taxInquiryTransaction ? `${(value.taxInquiryTransaction || '').name1 || ''} ${(value.taxInquiryTransaction || '').name2 || ''}` : {};
        tempResults.push(value);
      }
      return tempResults;
    },
  },
};
</script>

<style>
.hide-footer-select .v-data-footer__select {
  display: none;
}
</style>
